import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../images/logo.png";
import ToggleNav from "../components/ToggleNav";
// import Logo from '../images/logo.png';
// import LogoMini from '../images/logo-mini.png'

import LogoStolity from "../images/LogoStolity.png";
import LogoStolityMini from "../images/NewLogo.svg";
import { ChakraProvider, Stack, useToast } from "@chakra-ui/react";
import homeSidebar from "../images/homeSidebar.svg";
import profileSidebar from "../images/profileSidebar.svg";
import settingsSidebar from "../images/settingsSidebar.svg";
const apiUrl = process.env.REACT_APP_API_ENDPOINT;
const token = sessionStorage.getItem("number");

// Material-UI Icons
import DownloadIcon from "@mui/icons-material/Download";
import FolderIcon from "@mui/icons-material/Folder";
import DescriptionIcon from "@mui/icons-material/Description";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";

import axios from "axios";
import { useSelector } from "react-redux";

const SideNav = () => {
  const location = useLocation();
  const [openMenus, setOpenMenus] = useState({});
  const [activeMenu, setActiveMenu] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true); // State to manage sidebar visibility
  // Anurag's declaration
  const navigate = useNavigate();
  const token = sessionStorage.getItem("number");
  const count = useSelector((state) => state.getdata.counter);
  const apiUrl = process.env.REACT_APP_API_ENDPOINT;
  const [defaultFolders, setDefaultFolders] = useState([]);
  // Function to handle main menu click
  const handleMenuClick = (menu) => {
    setOpenMenus((prevOpenMenus) => ({
      ...Object.keys(prevOpenMenus).reduce((acc, key) => {
        acc[key] = key === menu ? !prevOpenMenus[menu] : false; // Close other menus and toggle the clicked menu
        return acc;
      }, {}),
    }));
    setActiveMenu(menu);
  };

  // useEffect(() => {
  //   const fetchDefaultFolders = async () => {
  //     try {
  //       const res = await axios.get(`${apiUrl}/default-folders`, {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //       });
  //       setDefaultFolders(res.data.result);
  //     } catch (error) {
  //       console.error("Error fetching default folders:", error);
  //       showToast("error", "Failed to load default folders");
  //     }
  //   };

  //   fetchDefaultFolders();
  // }, [apiUrl, token]);

  // Map folder names to Material-UI icons
  
  
  
  const getFolderIcon = (folderName) => {
    switch (folderName.toLowerCase()) {
      case "downloads":
        return <DownloadIcon />;
      case "documents":
        return <DescriptionIcon />;
      case "videos":
        return <VideoLibraryIcon />;
      case "music":
        return <MusicNoteIcon />;
      case "photos":
        return <PhotoLibraryIcon />;
      default:
        return <FolderIcon />;
    }
  };

  // Function to handle sidebar toggle
  const handleSidebarToggle = () => {
    setSidebarOpen((prevState) => !prevState);
  };

  // Effect to set active menu based on route change
  useEffect(() => {
    const path = location.pathname;
    const pathMap = {
      "/Home": "Home",
      "/Files": "FilesPage",
      "/AddFiles": "AddFilesPage",
      "/QrCode": "QRCode",
      "/AddQrCode": "QRCode",
      "/ShortLink": "ShortLink",
      "/TextDetect": "TextDetect",
      "/FaceDetect": "FaceDetect",
      "/ChangePassword": "ChangePassword",
      "/nested": "FilesPage",
      "/UserProfile": "UserProfile",
    };
    // console.log("counter value is", count);
    const menu = Object.keys(pathMap).find((key) => path.startsWith(key));
    const activeMenu = menu ? pathMap[menu] : null;

    setActiveMenu(activeMenu);
    setOpenMenus(activeMenu ? { [activeMenu]: true } : {});
    setSidebarOpen(true); // Ensure the sidebar is open when navigating to a new page
  }, [location.pathname]);

  // Ensure sidebar is open on initial render
  useEffect(() => {
    setSidebarOpen(true);
  }, []);
  // Anurag's code
  //Code to handle Log out
  const handleLogout = () => {
    console.log("Logout button clicked");
    axios
      .get(`${apiUrl}logout-user`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Example: setting content type
          // Add other headers if required
        },
      })
      .then((res) => {
        showToast("success", "You have logged out successfully!");
        console.log("Response received:", res.data);

        navigate("/Login");
        sessionStorage.clear();
      })
      .catch((error) => {
        showToast("error", `There's an error while logging out!`);
        console.log(error.response.data.error);
      });
  };
  const toast = useToast();

  const showToast = (status, message) => {
    toast({
      title: `${status.charAt(0).toUpperCase() + status.slice(1)}`,
      description: message,
      status: status, // Set this to 'error' for a red-colored pop-up
      duration: 3000,
      isClosable: true,
    });
  };
  return (
    <>
      <nav
        className={`sidebar sidebar-offcanvas ${
          sidebarOpen ? "open" : "closed"
        }`}
        id="sidebar"
      >
        <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
          <Link className="sidebar-brand brand-logo" to="/Files">
            <img src={LogoStolity} alt="logo" />
          </Link>
          <Link className="sidebar-brand brand-logo-mini" to="/Files">
            <img
              src={LogoStolityMini}
              alt="logo"
              style={{ height: "40px", width: "40px" }}
            />
          </Link>
        </div>

        <div className="left_navigation_row">
          <ul className="nav">
            <li
              className={`nav-item menu-items ${
                activeMenu === "FilesPage" ? "active" : ""
              }`}
            >
              <Link
                className="nav-link ripple_effect"
                to="/Files"
                onClick={() => setSidebarOpen(true)}
              >
                <span
                  className={`menu-icon ${
                    activeMenu === "FilesPage" ? "active-icon" : ""
                  }`}
                >
                  {/* Home Icon */}
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="sidebar-icon"
                  >
                    <path
                      d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9 22V12H15V22"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                {/* <span className="menu-title">Files List</span> */}
              </Link>
            </li>

            <li
              className={`nav-item menu-items ${
                activeMenu === "UserProfile" ? "active" : ""
              }`}
            >
              <Link
                className="nav-link ripple_effect"
                to="/UserProfile"
                onClick={() => setSidebarOpen(true)}
              >
                <span
                  className={`menu-icon ${
                    activeMenu === "UserProfile" ? "active-icon" : ""
                  }`}
                >
                  {/* Profile Icon */}
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="sidebar-icon"
                  >
                    <path
                      d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                {/* <span className="menu-title">Profile</span> */}
              </Link>
            </li>

            {/* Default Folders Section */}
            {/* {defaultFolders.map((folder) => (
              <li
                key={folder.fileName}
                className={`nav-item menu-items ${
                  location.pathname === `/folder/${folder.fileName}`
                    ? "active"
                    : ""
                }`}
                onClick={() => {
                  navigate(`/folder/${folder.fileName}`);
                }}
              >
                <div className="nav-link ripple_effect">
                  <span
                    className="menu-icon"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    {getFolderIcon(folder.fileName)}
                  </span>
                  {sidebarOpen && (
                    <span
                      className="menu-title"
                      style={{ textTransform: "capitalize" }}
                    >
                      {folder.fileName}
                    </span>
                  )}
                </div>
              </li>
            ))} */}
          </ul>
          <div className="footer_left">
            <button
              className="logout_button ripple_effect"
              onClick={handleLogout}
            >
              <i className="icon-logout" />
              <span className="menu-title">Logout</span>
            </button>
          </div>
        </div>
      </nav>
    </>
  );
};

export default SideNav;
